import useFormatNumber from './useFormatNumber';

function useFormatCurrency() {
  const formatNumber = useFormatNumber();
  return (value: number, options?: Intl.NumberFormatOptions) =>
    formatNumber(value, { ...options, style: 'currency', currency: 'EUR' });
}

export default useFormatCurrency;
